import React from "react";
import { Grid, Typography, Icon } from "../../components";

var IncludedServicesList = function IncludedServicesList(_a) {
  var title = _a.title,
      services = _a.services,
      _b = _a.background,
      background = _b === void 0 ? "#ececec" : _b,
      _c = _a.justifyContent,
      justifyContent = _c === void 0 ? "flex-start" : _c,
      anchor = _a.anchor,
      py = _a.py;
  return React.createElement(Grid.Container, {
    id: anchor,
    fluid: true,
    background: background,
    py: py
  }, React.createElement(Grid.Container, {
    py: "4rem"
  }, React.createElement(Grid.Row, null, React.createElement(Grid.Col, {
    lg: {
      size: 6,
      offset: 3
    }
  }, React.createElement(Typography, {
    variant: "h2",
    textAlign: "center",
    isUpperCase: true,
    mb: "3rem"
  }, title))), React.createElement(Grid.Row, {
    sx: {
      justifyContent: justifyContent
    }
  }, services.map(function (service) {
    return React.createElement(Grid.Col, {
      xs: 12,
      md: 4,
      lg: 3
    }, React.createElement("div", {
      style: {
        width: "74px",
        height: "74px",
        backgroundColor: "#ffa203",
        borderRadius: "50%",
        padding: "0.5rem",
        color: "white"
      }
    }, React.createElement(Icon, {
      name: service.icon
    })), React.createElement(Typography, {
      variant: "h5",
      color: "brandGreen",
      mt: "1rem"
    }, service.title), React.createElement(Typography, {
      color: "darkGreen",
      mb: "3rem"
    }, service.description));
  }))));
};

export default IncludedServicesList;